import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  /** Optional class hook so individual screens can layer their own styling. */
  className?: string
}

/**
 * Wraps a screen with the subtle slide + fade transition used throughout the quiz.
 * Consumes AnimatePresence's exit animations - must be a direct child of a keyed route.
 */
export function ScreenTransition({ children, className }: Props) {
  return (
    <motion.main
      className={className ? `fq-screen ${className}` : 'fq-screen'}
      initial={{ opacity: 0, x: 16 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -16 }}
      transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
    >
      {children}
    </motion.main>
  )
}
